import { ActivatedRoute } from '@angular/router';
import { PublicPlacesService, PublicPlacesSettings } from './../../../../core/services/public-places.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prominent-places',
  templateUrl: './prominent-places.component.html',
  styleUrls: ['./prominent-places.component.scss']
})
export class ProminentPlacesComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */
  publicPlacesSettings!: PublicPlacesSettings;
  lang!: string;
/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private publicPlacesService: PublicPlacesService,
    private route: ActivatedRoute) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(data=>{
      this.lang = data.get('lang')?? 'en';
    })
    this.publicPlacesService.getPublicPlacesSettings().subscribe(data=>{
      this.publicPlacesSettings = data;
    });
  }

}
